export default __webpack_public_path__ + "static/media/skull-player-dark.bc6283cd.svg";